<script setup lang="ts">
import useModuleStore from '@/stores/moduleStore';
import { storeToRefs } from 'pinia';
import { onMounted } from 'vue';
import  ModalConfirm from '../common/ModalConfirm.vue';
import { useModal } from 'vue-final-modal';
import { ref } from 'vue';

const moduleStore = useModuleStore();
const { modules } = storeToRefs(moduleStore);

onMounted(() => {
  if(!moduleStore.isLoaded) {
    moduleStore.fetchAll(true);
  }
})
function showMessage() {
  instance.open();
}


const instance = useModal({
  component: ModalConfirm,
  attrs: {
    title: ref('I utvikling'),
    onConfirm() {
      instance.close();
    }
  },
  slots: {
    default: 'Operasjonen støttes ikke ennå'
  },
})
</script>
<template>
<div class="container" v-if="modules.length > 0">
    <div v-for="(module, index) in modules" class="entry" :key="module.id">
      <span>{{module.title}}</span>
      <span class="icons">
        <font-awesome-icon v-if="index > 0" :icon="['fas', 'arrow-up']" size="lg" style="color: #00965a"></font-awesome-icon>
        <font-awesome-icon v-if="index == 0" :icon="['fas', 'arrow-up']" size="lg" style="color: #999"></font-awesome-icon>
        <font-awesome-icon v-if="index != modules.length -1" :icon="['fas', 'arrow-down']" size="lg" style="color: #00965a"></font-awesome-icon>
        <font-awesome-icon v-if="index == modules.length -1" :icon="['fas', 'arrow-down']" size="lg" style="color: #999"></font-awesome-icon>
        <font-awesome-icon :icon="['fas', 'eye-slash']" size="lg" style="color: #00965a"></font-awesome-icon>
        <font-awesome-icon :icon="['fas', 'eye']" size="lg" style="color: #999"></font-awesome-icon>
      </span>
    </div>
</div>
</template>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.icons {
  display: flex;
  flex-direction: row;
  gap: 6px;
  cursor: pointer;
}

.entry {
  background-color: #f0f0f0;
  color: black;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.entry-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
</style>
